export default __webpack_public_path__ + "static/media/nombre-examen.a212a5d1.svg";